module.exports = __webpack_public_path__ + "img/drugs-risk-factors.f19c5237.png";